<template>
  <div class="jobDetail breadcrumbs-absolute aboutUs Disclaimer" :class="{'aboutUsPC':$store.state.innerWidth>768}">
    <div class="header jobPosingSearch row flexHeader flexHeaderJia200">
    <Breadcrumbs></Breadcrumbs>
        <div class="warp-mask"></div>
        <div class="job-containers-center col-sm-10 col-md-8 padLeft-0 padRight-0">
            <h1 class="Bold" :class="{'font-size-60':$store.state.innerWidth>768}"> {{$t('message.Disclaimer')}}</h1>
        </div>
    </div>
    <div class="opp-contain row">
      <div class="about-pc marin-b-100">
        <div class="descriptionPC-right col-sm-12 col-md-12 padLeft-0 padRight-0" >
            <div class="contentGroup padding-b-50">
               <div class="page1" >
                 <div v-if="this.$store.state.language == 'en_US'">
                    <p>
                    The information provided by Special Administrative Region on this website is for reference only. Whilst the Government endeavours to ensure the accuracy of information on this site, no express or implied warranty is given by the Government as to the accuracy of information.
                  </p>
                    <p>
                    This web site also contains information input by other parties and users may link this site to other sites and obtain information provided by other parties (collectively called “the other information”). The Government expressly states that it has not approved or endorsed the other information contained in or in connection with this site. The links to other websites are provided for visitors' convenience and the information so provided is the responsibility of that external source.
                    </p>
                    <p>
                   The Government does not accept any responsibilities for any loss or damage whatsoever arising from any cause whatsoever in connection with this website. The Government is entitled to delete, suspend or edit all information on this site at any time at its absolute discretion without giving any reason. Users are responsible for making their own assessments of all information contained in or obtained in connection with this site and are advised to verify such information by making reference to its original publication and obtain independent advice before acting on it.
                    </p>
                 </div>
                  <div v-if="this.$store.state.language == 'zh_HK'">
                    <p>
                    香港特別行政區政府在本網站所提供的資料只供參考之用。雖然特區政府已盡力確保本網站內的政府資料準確無誤，但特區政府不對該等資料的準確性作出任何明示或隱含的保證。
                  </p>
                    <p>
                    本網址亦載有由其他各方輸入的資料，使用者亦可透過將本網址連接到其他網址而取得由其他各方所提供的資料(統稱「其他資料」)。特區政府明確聲明並沒有批准或認可本網站所載的其他資料或與本網站有關連的其他資料。本網站提供途徑連接到其他網站，旨在方便使用者，而循該等途徑取得的資料，概由有關的外間資料提供者負責。
                    </p>
                    <p>
                   如與本網站有關連的任何因由導致任何損失或損害，特區政府概不負責。特區政府無須給予任何理由，即可行使絕對酌情權，隨時刪除、暫時停載或編輯本網站內的各項資料。使用者須負責自行評估本網站所載或透過本網站所取得的各項資料。使用者應先參考原本發布的文本以核實該等資料，並徵詢獨立的意見，然後才根據該等資料行事。
                    </p>
                 </div>
                  <div  v-if="this.$store.state.language == 'zh_CN'">
                    <p>
                    香港特别行政区政府在本网站所提供的数据只供参考之用。虽然特区政府已尽力确保本网站内的政府资料准确无误，但特区政府不对该等资料的准确性作出任何明示或隐含的保证。
                  </p>
                    <p>
                    本网址亦载有由其他各方输入的数据，用户亦可透过将本网址连接到其他网址而取得由其他各方所提供的数据(统称「其他数据」)。特区政府明确声明并没有批准或认可本网站所载的其他数据或与本网站有关连的其他数据。本网站提供途径连接到其他网站，旨在方便使用者，而循该等途径取得的数据，概由有关的外间资料提供者负责。
                    </p>
                    <p>
                   如与本网站有关连的任何因由导致任何损失或损害，特区政府概不负责。特区政府无须给予任何理由，即可行使绝对酌情权，随时删除、暂时停载或编辑本网站内的各项数据。使用者须负责自行评估本网站所载或透过本网站所取得的各项数据。使用者应先参考原本发布的文本以核实该等数据，并征询独立的意见，然后才根据该等资料行事。
                    </p>
                 </div>
               </div>
               <img class="bgImg2 noSelect" v-if="$store.state.innerWidth<=1120" src="../images/deco-18.png" />
            </div>
        </div>
      </div>
      <img class="bgImg noSelect" v-if="$store.state.innerWidth>1120" src="../images/deco-18.png" />
    </div>
  </div>
</template>
<script>
import Breadcrumbs from "@/components/Breadcrumbs";

export default {
  name:"disclaimer",
  data() {
    return {
        }
    },   
  props:[
  ],
  components: {
    Breadcrumbs,
  },
  created() {},
  methods: {
  },
  mounted() {
    var that = this;
    setTimeout(function(){
      that.$store.state.mate.title = that.$i18n.t("message."+that.$route.meta.title)+' - talent.gov.hk - '+that.$i18n.t("message.Default Page Title");
    })

    this.$store.state.selectMenu = 0;
  }
};
</script>